export enum ReportActionType {
    LIST = 'list_reports',
    PAGINATE = 'paginate_reports',
    LIST_LAST = 'list_last_reports',
    CREATE = 'create_report',
    UPDATE = 'update_report',
}